"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodDatatrans = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Select_1 = require("./Select");
const PaymentMethodDatatrans = (props) => {
    const { select, hidden, modificators } = props;
    if (hidden)
        return null;
    return (react_1.default.createElement(Select_1.PaymentMethodSelect, { icon: 'datatrans', select: select, title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Payment/Method:Datatrans', defaultMessage: 'Datatrans (1.5% payment fee)' }), modificators: modificators }));
};
exports.PaymentMethodDatatrans = PaymentMethodDatatrans;
//# sourceMappingURL=Datatrans.js.map